import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import CryptoJS from "crypto-js";
import Overview from "../../Pages/Overview/Overview";
import Complaints from "../../Pages/Complaints/Complaints";
import IncentiveManagement from "../../Pages/Incentive Mangement/Incentive";
import Services from "../../Pages/Services/Service";
import CustomerPaymentHistory from "../../Pages/Customer Payment History/CustomerPyamentHistory";
import Transactions from "../../Pages/Transactions/Transactions";
import Simpl from "../../Pages/SIMPL/Simpl";
import Refund from "../../Pages/Transactions/Refund";
import Unauthorized from "../../Pages/Unauthorized/Unauthorized";
import User from "../../Pages/Users/User";
import CustomerParameters from "../../Pages/Customer Parameters/CustomerParameters";
import ClientCredential from "../../Pages/Client Credential/clientCredential";
import EmailInbox from "../../Pages/Mails";
import HelpSupport from "../../Pages/HelpSupport/HelpSupport";
// import Prepaid from "../../Pages/prepaid/Prepaid";
import Prepaid from "../../Pages/prepaid/DashBoard";
import Category from "../../Pages/Category/category";
import { useSelector } from "react-redux";
import decryptedModulesData from "../../utils/decryptedModulesData";

function AppRouters() {
  
  const permissions = decryptedModulesData().modules || [];
  return (
    <div className="AppPageConntent">
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/transactions" element={checkPermission(permissions, "Transactions") ? <Transactions /> : <Navigate to="/unauthorized" />} />
        <Route path="/client-Credential" element={checkPermission(permissions, "transactions") ? <ClientCredential /> : <Navigate to="/unauthorized" />} />
        {/* <Route path="/refund" element={checkPermission(permissions, "refund") ? <Refund /> : <Navigate to="/unauthorized" />} /> */}
        <Route path="/complaints" element={checkPermission(permissions, "complaints") ? <Complaints /> : <Navigate to="/unauthorized" />} />
        <Route path="/category" element={checkPermission(permissions, "commision history") ? <Category /> : <Navigate to="/unauthorized" />} />
        {/* <Route path="/incentive-management" element={checkPermission(permissions, "incentive_management") ? <IncentiveManagement /> : <Navigate to="/unauthorized" />} /> */}
        <Route path="/customer-payment-history" element={checkPermission(permissions, "Customer Payment History") ? <CustomerPaymentHistory /> : <Navigate to="/unauthorized" />} />
        {/* <Route path="/simpl" element={checkPermission(permissions, "simpl") ? <Simpl /> : <Navigate to="/unauthorized" />} /> */}
        <Route path="/users" element={checkPermission(permissions, "Users") ? <User /> : <Navigate to="/unauthorized" />} />
        {/* <Route path="/customer-parameters" element={checkPermission(permissions, "customer-parameters") ? <CustomerParameters /> : <Navigate to="/unauthorized" />} /> */}
        <Route path="/mails" element={checkPermission(permissions, "mails") ? <EmailInbox /> : <Navigate to="/unauthorized" />} />
        {/* <Route path="/services" element={checkPermission(permissions, "service_list") ? <Services /> : <Navigate to="/unauthorized" />} /> */}
        <Route path="/help-support" element={checkPermission(permissions, "help & support") ? <HelpSupport /> : <Navigate to="/unauthorized" />} />
        <Route path="/prepaid" element={checkPermission(permissions, "prepaid") ? <Prepaid /> : <Navigate to="/unauthorized" />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Unauthorized />} />
      </Routes>
    </div>
  );
}

function checkPermission(permissions, requiredPermission) {
  return permissions.some(
    (permission) =>
      permission.module.toLowerCase() === requiredPermission.toLowerCase() &&
      permission.read
  );
}

export default AppRouters;
